exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-77df5b07]{max-width:100%\n}\n.panels-container[data-v-77df5b07]{display:flex;justify-content:center;margin:auto;max-width:100%;padding:92px 12px 12px\n}\n.panels[data-v-77df5b07]{background:transparent;flex-grow:1;height:calc(100vh - 92px);margin:12px;max-width:50%;overflow-y:auto;width:25%\n}\n.panels .layout .container[data-v-77df5b07]{padding:0\n}", ""]);

// exports
